import BaseField from "./BaseField";

export class EmailField extends BaseField {
    constructor(props) {
        super(props);
        this.state = {
            wrongFormat: false,
        }
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
    }

    validateEmail(mail)
    {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
    }

    handleDataUpdate(value){
        this.props.collectData(this.props.id, value)
        let currThis = this;
        setTimeout(function () {
            currThis.setState({
                wrongFormat: value !== '' && !currThis.validateEmail(value),
            })
        }, 500)
    }

    renderErrorMessage(){
        let message = '';
        if(!this.props.IsValid){
            message = this.props.ErrorMessage;
        } else {
            if(this.state.wrongFormat){
                message = this.props.ErrorMessageWrongFormat;
            }
        }
        return(
            <span className="errorMessage">
                {message}
            </span>
        )
    }

    render(){
        return (
            <div className={this.props.Columns}>
                <div className="field text">
                    <label className="">
                        {this.renderLabelText()}
                    </label>
                    <input id={this.props.id} type="email" className="text form-control" value={this.props.value} placeholder={this.props.Placeholder} required={this.props.Required} onChange={(e) => {this.handleDataUpdate(e.target.value)}} />
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default EmailField;